import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import FeatureNewsCard from "./FeatureNewsCard";
import { getFeatureNewsDesign } from "./featureNewsDesigns";
import { useFeatureNewsPanelSize } from "./featureNewsLayout";
import { buildFeatureNewsSlides } from "./sanitizeNewsHtml";
import "./featureNews.css";

const FeatureNewsModal = ({ open, items, onDismiss }) => {
  const { viewerWidth } = useFeatureNewsPanelSize();
  const slides = useMemo(() => buildFeatureNewsSlides(items), [items]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (open) {
      setIndex(0);
    }
  }, [open, slides.length]);

  const current = slides[index] || slides[0];
  const isLast = index >= slides.length - 1;
  const design = getFeatureNewsDesign(current?.designId);

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      mask
      width={viewerWidth}
      destroyOnHidden
      onCancel={onDismiss}
      rootClassName="feature-news-viewer"
      className="feature-news-viewer"
      styles={{
        mask: {
          background: "rgba(28, 22, 18, 0.45)",
        },
        content: {
          background: "transparent",
          boxShadow: "none",
          padding: 0,
        },
        body: { padding: 0 },
      }}
    >
      {current ? (
        <div className={`feature-news-dock feature-news-dock--${design.id}`}>
          <FeatureNewsCard item={current} onClose={onDismiss} />
          <div className="feature-news-dock-footer">
            <div className="feature-news-footer-left">
              {slides.length > 1 ? (
                <div className="feature-news-progress">
                  {slides.map((slide, slideIndex) => (
                    <button
                      key={slide.slideId}
                      type="button"
                      className={`feature-news-progress-dot${slideIndex === index ? " is-active" : ""}`}
                      onClick={() => setIndex(slideIndex)}
                      aria-label={`Show page ${slideIndex + 1}`}
                    />
                  ))}
                  <span className="feature-news-progress-count">
                    {index + 1} of {slides.length}
                  </span>
                </div>
              ) : null}
              <p className="feature-news-faq-hint">
                <QuestionCircleOutlined />
                <span>More detail in the FAQ, top right</span>
              </p>
            </div>
            <div className="feature-news-actions">
              {!isLast ? (
                <Button onClick={() => setIndex((value) => value + 1)}>Next</Button>
              ) : null}
              <Button type="primary" onClick={onDismiss}>
                Got it
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default FeatureNewsModal;
